function t(t) {
  if ("" !== t)
    try {
      return JSON.parse(t);
    } catch (e) {
      return t;
    }
}
class e extends HTMLElement {
  constructor() {
    super(),
      (this.parsedDataset = Object.entries(this.dataset).reduce(
        (e, [i, s]) => ({ ...e, [i]: t(s) }),
        {}
      )),
      (this.mounted = !1);
  }
  connectedCallback() {
    this.mounted ||
      (this.emit("mount"), this.componentDidMount(), (this.mounted = !0));
  }
  componentDidMount() {}
  on(t, e, i) {
    !(function (t, e, i = {}, s) {
      s.addEventListener(
        t,
        (t) => {
          i.preventDefault && t.preventDefault();
          const { target: s, detail: n } = t;
          e({ target: s, data: n });
        },
        i
      );
    })(t, e, i, this);
  }
  emit(t, e) {
    let i = `${this.tagName.toLowerCase()}.${t}`;
    "string" == typeof this.parsedDataset.action &&
      (i += `.${this.parsedDataset.action}`),
      this.dispatchEvent(new CustomEvent(i, { detail: e, bubbles: !0 }));
  }
  context(t) {
    return this.closest("product-context").get(t);
  }
}

function i(t) {
  return t <= 9 ? "0" + t : t;
}

customElements.define(
  'c-button',
  class extends e {
    constructor() {
      super(), (this.handleClick = this.handleClick.bind(this));
    }
    componentDidMount() {
      this.addEventListener('click', this.handleClick);
    }
    handleClick() {
      this.emit('click', { action: this.parsedDataset.action });
    }
  }
),
  customElements.define(
    'c-checkbox',
    class extends e {
      constructor() {
        super(),
          (this.elements = { label: this.querySelector('.Checkbox__Label') }),
          (this.active = this.classList.contains('Checkbox--Active')),
          (this.handleClick = this.handleClick.bind(this)),
          (this.toggleActiveState = this.toggleActiveState.bind(this));
      }
      componentDidMount() {
        this.addEventListener('click', this.handleClick);
      }
      handleClick() {
        this.toggleActiveState();
      }
      toggleActiveState() {
        this.classList.toggle('Checkbox--Active', !this.active),
          (this.active = !this.active),
          (this.elements.label.textContent = this.active ? this.parsedDataset.checkedLabel : this.parsedDataset.label);
      }
    }
  ),
  customElements.define(
    'c-countdown',
    class extends e {
      constructor() {
        super();

        // Find time display element
        this.timeElement = this.querySelector('.Countdown__Time');

        // Parse timer from data-timer (e.g. "05:30")
        const timer = this.parsedDataset.timer;

        if (timer) {
          const [minutes, seconds] = timer.split(':').map(value => parseInt(value, 10));
          const totalSeconds = (minutes * 60) + seconds;
          this.remainingTimeInMilliseconds = totalSeconds * 1000;
        }
      }

      componentDidMount() {
        if (!this.remainingTimeInMilliseconds) return;

        // Show initial time
        this.updateDisplay();

        // Update every second
        setInterval(() => {
          this.remainingTimeInMilliseconds -= 1000;

          // Stop at 0 and hide element
          if (this.remainingTimeInMilliseconds <= 0) {
            this.remainingTimeInMilliseconds = 0;
            this.updateDisplay();
            this.style.display = 'none';
            return;
          }

          this.updateDisplay();
        }, 1000);
      }

      updateDisplay() {
        const minutes = Math.floor(this.remainingTimeInMilliseconds / (1000 * 60)) % 60;
        const seconds = Math.floor(this.remainingTimeInMilliseconds / 1000) % 60;

        const timeString = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
        this.timeElement.textContent = timeString;
      }

      padZero(value) {
        return value <= 9 ? '0' + value : value;
      }
    }
  ),
  customElements.define(
    'language-selector',
    class extends e {
      constructor() {
        super(),
          (this.elements = {
            form: this.querySelector('form'),
            select: this.querySelector('select'),
            input: this.querySelector('input[name="language_code"]'),
          });
      }
      componentDidMount() {
        if (!this.elements) {
          return;
        }
        this.elements.select.addEventListener('change', this.handleLanguageChange.bind(this));
      }
      handleLanguageChange(t) {
        const e = t.target.value;
        (this.elements.input.value = e), this.elements.form.submit();
      }
    }
  ),
  customElements.define(
    'c-modal',
    class extends e {
      constructor() {
        super(),
          (this.usePortal = this.parsedDataset.usePortal),
          (this.elements = {
            modal: this.querySelector('.c-Modal__Modal'),
            modalContent: this.querySelector('.c-Modal__Content'),
            overlay: this.querySelector('.c-Modal__Overlay'),
            modalPortal: document.querySelector('.c-Modal--Portal'),
          }),
          (this.handleOpen = this.handleOpen.bind(this)),
          (this.handleClose = this.handleClose.bind(this));
      }
      componentDidMount() {
        this.addEventListener('c-button.click.open-modal', this.handleOpen),
          this.addEventListener('c-button.click.close-modal', this.handleClose),
          this.elements.overlay.addEventListener('click', this.handleClose);
      }
      handleOpen() {
        this.usePortal && this.elements.modalPortal
          ? (this.elements.modalPortal.replaceModalContent(this.elements.modalContent),
            this.elements.modalPortal.open())
          : this.open();
      }
      open() {
        this.elements.modal.classList.add('c-Modal__Modal--Active');
      }
      handleClose() {
        this.close();
      }
      close() {
        this.elements.modal.classList.remove('c-Modal__Modal--Active');
      }
      replaceModalContent(t) {
        this.elements.modalContent.innerHTML = t.innerHTML;
      }
    }
  ),
  customElements.define(
    'shipping-notification',
    class extends e {
      constructor() {
        super(),
          (this.elements = {
            dot: this.querySelector('.ShippingNotification__Dot'),
            text: this.querySelector('.Text'),
          }),
          (this.available = this.parsedDataset.available),
          (this.texts = {
            available: this.parsedDataset.availableText,
            unavailable: this.parsedDataset.unavailableText,
          }),
          (this.productJSON = JSON.parse(document.querySelector('[data-product-json]').textContent)),
          (this.selectedVariant = this.productJSON.variants.find((t) => t.id === this.productJSON.selected_variant_id));
      }
      connectedCallback() {
        globalThis.addEventListener('variant:changed', (event) => {
          const { detail: variantData } = event;

          if (variantData.variant) {
            // Find the corresponding variant in the productJSON using the variant ID
            this.selectedVariant = this.productJSON.variants.find((variant) => variant.id === variantData.variant.id);

            if (variantData.variant.available) {
              this.setAvailable(); // Set the UI state to "available"
            } else {
              this.setUnavailable(); // Set the UI state to "unavailable"
            }

            this.show(); // Display relevant UI changes for the selected variant
          }
        });
      }
      show() {
        this.setAttribute('aria-hidden', 'false');
      }
      setAvailable() {
        this.selectedVariant.shippingNotificationAvailableTextOverride
          ? (this.elements.text.textContent = this.selectedVariant.shippingNotificationAvailableTextOverride)
          : (this.elements.text.textContent = this.texts.available),
          this.elements.text.classList.add('Text--Success'),
          this.elements.text.classList.remove('Text--Error'),
          this.elements.dot.classList.add('ShippingNotification__Dot--Success'),
          this.elements.dot.classList.remove('ShippingNotification__Dot--Error'),
          (this.available = !0);
      }
      setUnavailable() {
        (this.elements.text.textContent = this.texts.unavailable),
          this.elements.text.classList.remove('Text--Success'),
          this.elements.text.classList.add('Text--Error'),
          this.elements.dot.classList.remove('ShippingNotification__Dot--Success'),
          this.elements.dot.classList.add('ShippingNotification__Dot--Error'),
          (this.available = !1);
      }
    }
  ),
  customElements.define(
    'story-menu',
    class extends e {
      constructor() {
        super(),
          (this.handleScroll = this.handleScroll.bind(this)),
          (this.updateGradients = this.updateGradients.bind(this)),
          (this.hideGradientRight = this.hideGradientRight.bind(this)),
          (this.showGradientRight = this.showGradientRight.bind(this)),
          (this.hideGradientLeft = this.hideGradientLeft.bind(this)),
          (this.showGradientLeft = this.showGradientLeft.bind(this));
      }
      componentDidMount() {
        this.getElements(),
          (this.scrollDistanceMaxThreshold = 10),
          (this.scrollDistanceMax =
            this.elements.itemList.scrollWidth - this.elements.itemList.offsetWidth - this.scrollDistanceMaxThreshold),
          this.updateGradients(),
          this.elements.itemList.addEventListener('scroll', this.handleScroll);
      }
      getElements() {
        this.elements = { itemList: this.querySelector('.StoryMenu__List') };
      }
      handleScroll() {
        this.updateGradients();
      }
      updateGradients() {
        const t = this.elements.itemList.scrollLeft;
        t >= this.scrollDistanceMax ? this.hideGradientRight() : this.showGradientRight(),
          t >= this.scrollDistanceMaxThreshold ? this.showGradientLeft() : this.hideGradientLeft();
      }
      hideGradientRight() {
        this.classList.remove('StoryMenu--GradientRight');
      }
      showGradientRight() {
        this.classList.add('StoryMenu--GradientRight');
      }
      hideGradientLeft() {
        this.classList.remove('StoryMenu--GradientLeft');
      }
      showGradientLeft() {
        this.classList.add('StoryMenu--GradientLeft');
      }
    }
  ),
  document.querySelectorAll('[data-action="open-drawer"]').forEach((t) => {
    t.addEventListener('click', () => {
      try {
        const t = document.querySelector('.SidebarMenu__Nav .Collapsible__Button');
        if (t) {
          'true' === t.getAttribute('aria-expanded') || t.click();
        }
      } catch (error) {
        console.error('An error occurred:', error.message);
      }
    });
  });

function t(t) {
  if ("" !== t)
    try {
      return JSON.parse(t);
    } catch (e) {
      return t;
    }
}

customElements.define(
  "buy-it-with",
  class extends e {
    constructor() {
      super(),
        (this.elements = { checkbox: this.querySelector(".Checkbox") }),
        (this.variantId = this.parsedDataset.variantId),
        (this.productOptionValue = this.parsedDataset.productOptionValue);
    }
    componentDidMount() {
      globalThis.addEventListener("variant:changed", (t) => {
        const { data: e } = t;
        e.variant &&
          (e.variant.option1 === this.productOptionValue
            ? this.removeAttribute("hidden")
            : (this.setAttribute("hidden", "hidden"),
              this.elements.checkbox &&
                this.elements.checkbox.active &&
                this.elements.checkbox.toggleActiveState()));
      });
    }
  }
),
  customElements.define(
    "variant-description",
    class extends e {
      constructor() {
        super(),
          (this.handleVariantChange = this.handleVariantChange.bind(this));
      }
      componentDidMount() {
        (this.elements = {
          descriptions: this.querySelectorAll(".ProductMeta__Description"),
        }),
          globalThis.addEventListener(
            "variant:changed",
            this.handleVariantChange
          );
      }
      handleVariantChange(t) {
        const e = t.data.variant.id;
        this.updateVariantDescription(e);
      }
      updateVariantDescription(t) {
        this.elements.descriptions.forEach((e) => {
          const n = parseInt(e.getAttribute("data-variant-id"), 10) === t;
          e.classList.toggle("ProductMeta__Description--Active", n);
        });
      }
    }
  ),
  document.addEventListener("variant:changed", (t) => {
    const { variant: e } = t.detail;
    e && (window.venenengel.product.selectedVariant = e);
  });
